import { t } from "@lingui/core/macro";
import React, {Component} from 'react'
import Meta from "../Meta"
import Header from "../header"
import Footer from "../footer"
import AccountSpace from "../../../components/AccountSpace"

// Wrapper thème Ummah : habille le composant partagé AccountSpace avec le
// Header/Footer du site. Le composant lui-même reste agnostique du thème.
export default class AccountSpacePage extends Component {
    render() {
        const context = this.props.context
        return (
            <div>
                <Meta context={context} title={t`Mon espace`}/>
                <Header context={context}/>
                {/* marginTop : aère sous le header (pattern CustomPage), sinon le
                    contenu colle au header — surtout visible sur mobile. */}
                <div style={{minHeight: "70vh", marginTop: 32}}>
                    <AccountSpace context={context}/>
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}
